export default __webpack_public_path__ + "0b64e0f9940b7b92291db6ca4c74e273.svg";